<template>

    <div v-if="!planChanged">
        
        <div class="w-full pb-16">
            <div class="w-full max-w-2xl mx-auto">
                <div v-if="!selectedPlan">
                    <a href="/membership"
                        class="block w-full px-3 py-4 mt-4 mb-4 text-sm font-semibold text-center text-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay-600">Go
                        Back
                    </a>
                </div>

                <div v-else
                    class="max-w-2xl mx-auto bg-white shadow-2xl rounded-3xl ring-1 ring-gray-200 lg:max-w-none">
                    <div class="min-w-full py-4 mt-4 text-center text-green-900" v-if="isFetching">
                        Calculating change in plan...
                    </div>
                    <div v-else>
                        <div class=" lg:mx-0">
                            <div class="p-8 sm:px-10 ">
                               
                                <dl class="pr-8 mx-auto mt-8 text-sm divide-y divide-gray-200 lg:col-span-7 lg:mt-0 lg:max-w-md">
                                   
                                    <div class="flex items-center justify-between py-4">
                                        <dt class="text-gray-600">Regular PRO {{selectedPlan.nameLabel}} Price</dt>
                                        <dd class="font-medium text-gray-900">{{
                                        formattedCurrency(previewPlanChange.newRecurringAmount)
                                        }}/year</dd>
                                    </div>
                                    
                                    <div class="flex items-center justify-between py-4">
                                        <dt class="text-gray-600">
                                            <input class="block w-full px-3 py-2 placeholder-gray-400 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-electric-500 focus:border-electric-500 sm:text-sm"
                                                   v-model="couponCode"
                                                   placeholder="Promotion Code"
                                            />
                                        </dt>
                                        <dd class="font-medium text-gray-900">
                                            <button :disabled="couponCode === ''" 
                                                    @click.prevent="onPlanSelected(selectedPlan)"
                                                    class="block w-full px-3 py-2 text-sm font-semibold text-center text-white bg-clay-600 rounded-md shadow-sm hover:bg-clay-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay-600" type="button">
                                                Apply </button>
                                        </dd>
                                    </div>

                                    <div v-if="previewPlanChange.discountAmount" class="flex items-center justify-between py-4">
                                        <dt class="text-clay-700">
                                            Discount Applied
                                        </dt>
                                        <dd class="font-medium text-clay-700">
                                            {{ formattedCurrency(previewPlanChange.discountAmount) }}
                                        </dd>
                                    </div>
                                    
                                </dl>

                                <ErrorSummary :response-status="responseStatus" />

                                <p class="mx-auto leading-7 text-center text-gray-600 text-md md:max-w-md"> 
                                
                                If you change to a Yearly PRO subscription, you will be billed the discounted rate of 
                                    <strong>{{ formattedCurrency(previewPlanChange.amountBilledToday) }}</strong>. Your subscription will renew at the regular price unless you cancel before your renewal date.
                                </p>
                            </div>
                            <div class="p-4 mx-auto -mt-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                <div
                                    class="py-10 text-center rounded-2xl bg-gray-50 ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-8">
                                    <div class="max-w-xs px-8 mx-auto">
                                        <p class="text-base font-semibold text-gray-600">Billed Today</p>
                                        <p class="flex items-baseline justify-center mt-6 gap-x-2">
                                            <span class="text-5xl font-bold tracking-tight text-gray-900">{{
                                                formattedCurrency(previewPlanChange.amountBilledToday)
                                                }}</span>
                                        </p>
                                        <SaButton @click.prevent="changePlan" :loading="processing" variant="primary">
                                            <template #loading>
                                                Processing...
                                            </template>
                                            Confirm Change
                                        </SaButton>
                                        
                                        <p class="mt-6 text-xs leading-5 text-gray-600">Please click CONFIRM CHANGE to
                                            proceed.</p>


                                    </div>
                                    <p class="px-8 mt-4 text-xs leading-5 text-gray-600 ">By confirming, you agree to the automatic renewal terms on this page, confirm your agreement to our <a class="underline" target="_blank" href="/pages/terms">Terms of Service</a> and re-acknowledge our <a target="_blank"  class="underline" href="/pages/privacy">Privacy Policy</a>.</p>
                                </div>
                            </div>

                        </div>
                        <div class="px-8 pb-4">
                            <div class="flex items-center mt-4 text-center gap-x-4">
                                <h4 class="flex-none mb-4 font-semibold leading-6 text-gray-600">Billing
                                    details
                                </h4>
                                <div class="flex-auto h-px bg-gray-100"></div>
                            </div>
                            <div role="list" class="mb-3 ml-3 text-sm leading-6 text-gray-600">
                                <dl class="pr-8 mt-8 text-sm divide-y divide-gray-200 lg:col-span-7 lg:mt-0">
                                   
                                    <div class="flex items-center justify-between py-4">
                                        <dt class="text-gray-600">Regular yearly price</dt>
                                        <dd class="font-medium text-gray-900">{{
                                        formattedCurrency(previewPlanChange.newRecurringAmount)
                                        }}/year</dd>
                                    </div>
                                    <div class="flex items-center justify-between py-4">
                                        <dt class="text-gray-600">Renews on</dt>
                                        <dd class="font-medium text-gray-900"><span class="font-semibold">{{ previewPlanChange.newPaymentDateInPstAsString
                                        }}</span></dd>
                                    </div>
                                    <div class="flex items-center justify-between py-4">
                                        <dt class="text-gray-600">Credit for unused time</dt>
                                        <dd class="font-medium text-green-700"><em class="">{{
                                        formattedCurrency(previewPlanChange.amountCreditedFromCurrentPlan)
                                        }}</em></dd>
                                    </div>
                                    <div class="flex items-center justify-between hidden py-4">
                                        <dt class="text-gray-600">Additional discount</dt>
                                        <dd class="font-medium text-clay-700"><em class=""></em></dd>
                                    </div>



                                    
                                    <div  class="flex items-center justify-between py-4">
                                        <dt class="font-semibold text-gray-600 uppercase">Billed Today</dt>
                                        <dd class="font-medium text-gray-900"><span class="font-semibold">{{
                                        formattedCurrency(previewPlanChange.amountBilledToday)
                                        }}</span></dd>
                                    </div>
                                </dl>
                                <p class="mt-4 text-center"><a href="/membership" class="underline hover:no-underline">Back to membership settings</a></p>
                            </div>
                            
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="max-w-2xl mx-auto">

            <h3 class="mb-3 text-lg font-semibold">Current Subscription</h3>
            <div class="px-6 py-4 pr-8 rounded-xl bg-gray-50">
                <dl class="">
                    <div>

                        <dd class="mt-3 text-clay-800">
                            <span class="block font-semibold">StageAgent PRO ({{ currentPlan.name }})</span>
                            <span class="block"></span>
                            <span class="block"><em> Your PRO membership gives you full access to expert-written theatre
                                    content and professional networking opportunities. </em></span>
                        </dd>
                    </div>

                </dl>

                <dl class="mt-8 text-sm divide-y divide-gray-200 ">
                    <div class="flex items-center justify-between pb-4">
                        <dt class="text-gray-600">Billed</dt>
                        <dd class="font-medium text-gray-900">{{ currentPlan.planPriceInWords }}</dd>
                    </div>
                    <div class="flex items-center justify-between py-4">
                        <dt class="text-gray-600">Paid through</dt>
                        <dd class="font-medium text-gray-900"> {{ currentPlan.currentPeriodEndFormatted }}</dd>
                    </div>


                </dl>
            </div>
        </div>
    </div>
    <div v-else
        class="max-w-4xl px-8 py-12 mx-auto mt-16 mb-32 text-center shadow-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 bg-zinc-50">
        <p class="mb-5 text-2xl font-semibold">Congratulations!</p>
        <p class="mb-5 text-xl">Congratulations you have successfully changed plans!</p>
        <p class="mt-10 mb-5"><a
                class="px-5 py-3 mb-5 text-base font-medium text-white bg-clay-900 border border-transparent rounded-md hover:bg-gray-900"
                href="/">Back
                to StageAgent Home</a></p>
        <p class=""><a href="/membership">Back to Membership</a></p>
    </div>


</template>

<script lang="ts" setup>
import {defineProps, onMounted, ref} from 'vue';
import {client} from '@/shared';
import {
    ChangeMembershipPlan,
    PreviewChangeMembershipPlan,
    PreviewChangeMembershipPlanResponse
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaButton from "@/main/components/SaButton.vue";

const props = defineProps<{
    currentPlan: any,
    changeablePlanNames: any []
}>();

let responseStatus = ref(null);
let allPlans = [
    {
        id: "yearly",
        name: "yearly",
        priceInCents: 14340,
        nameLabel: "StageAgent Yearly",
        perMonth: "$11.95/mo",
        priceLabel: "$11.95 USD",
        priceAnnually: "143.40",
        renewsAfterLabel: "year",
        radioDesc: "Billed $143.40 USD every year",
    }
];

let selectedPlan = ref(null)
let couponCode = ref('');
let planChangePreviewed = ref(false);
let planChanged = ref(false);
let processing = ref(false);

const previewPlanChange = ref(new PreviewChangeMembershipPlanResponse());

onMounted(async () => {
    await onPlanSelected(allPlans[0]);
});

const isFetching = ref(false);
const onPlanSelected = async (plan: any) => {
    selectedPlan.value = plan;
    isFetching.value = true;
    let data = {
        plan: selectedPlan.value.name,
        couponCode: couponCode.value
    };

    await client.post<PreviewChangeMembershipPlanResponse>(new PreviewChangeMembershipPlan(data))
        .then(response => {
            previewPlanChange.value = response;
            planChangePreviewed.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
        });
    isFetching.value = false;
};

const changePlan = async () => {
    processing.value = true;

    const data = {
        plan: selectedPlan.value.name,
        couponCode: couponCode.value
    };
    await client.post(new ChangeMembershipPlan(data))
        .then(r => {
            planChanged.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
        });

    processing.value = false;
};

const formattedCurrency = (amountInCents: any) => {
    let price = (amountInCents / 100).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    return price;
}

</script>
